import { Field, Form } from '~/components';
import React from 'react';
import LineSettingsProjectNameControl from './LineSettingsProjectNameControl';

function LineSettingsProductItemsTab() {
  return (
    <Form.Section title="General">
      <Form.Control>
        <Field.Checkbox
          label="Include the project name on each product invoice line"
          name="includeProductItemProject"
        />
      </Form.Control>
      <Form.Control>
        <LineSettingsProjectNameControl />
      </Form.Control>
    </Form.Section>
  );
}

export default LineSettingsProductItemsTab;
